<template>
  <div class="fts-expression formula-expression">
    <vue-tribute :options="tributeOptions">
      <div
        v-html="content"
        class="formula"
        placeholder="type formula here. # for hints"
        contenteditable="true"
        @click="test"
        @input="updateContent"
        @blur="onBlur"
        @keydown="processKeyDown"
        @keyup="debounceInput"
        @paste.prevent="paste($event)"
        ref="formulaExpression"
      ></div>
    </vue-tribute>
    <!-- <div class="editor-expression">
      {{ innerExpression }}
    </div>-->
  </div>
</template>
<script>
import VueTribute from "vue-tribute";
import "tributejs/dist/tribute.css";
import commons from "../commons/commons";

// import { automationDesignStore } from "../store/automationDesignStore";

let findLastFormulaUnit = function(rangeStart) {
  if (rangeStart && rangeStart.data && rangeStart.data.indexOf("#") == 0) {
    let breaker = 0;
    let primer = rangeStart.previousSibling;

    while (breaker < 4) {
      if (primer && primer.tagName == "FTS-I-UNIT") {
        return primer;
      } else if (!primer) {
        return null;
      }

      primer = primer.previousSibling;
      breaker++;
    }

    return null;
  }
};

var prepareVariables = function(information, vm, variableType) {
  let informationPart = information.map(function(x) {
    let moduleName = "";
    if (x.connectionId) {
      let moduleItem = vm.getModule(x.connectionId.toString());
      if (moduleItem) {
        moduleName = moduleItem.name;
      } else {
        moduleName = x.connection;
      }
    }

    return {
      fieldName: x.fieldName,
      type: x.type,
      name: x.displayName,
      fields: x.fields,
      moduleId: x.connectionId ? x.connectionId.toString() : null,
      moduleName: moduleName
    };
  });

  let systemPart = [
    {
      fieldName: "documentId",
      name: "Document ID",
      system: true,
      type: 0
    },
    {
      fieldName: "createdBy",
      name: "Created By",
      system: true,
      type: 0
    },
    {
      fieldName: "createdDate",
      name: "Created Date",
      system: true,
      type: 5
    },
    {
      fieldName: "lastChangeBy",
      name: "Last Change By",
      system: true,
      type: 0
    },
    {
      fieldName: "lastChangeDate",
      name: "Last Change Date",
      system: true,
      type: 5
    },
    {
      fieldName: "state",
      name: "State",
      system: true,
      type: 5
    }
  ];

  let constants = [
    // {
    //     fieldName: 'today',
    //     name: 'Today',
    //     constant: true,
    // },
    // {
    //     fieldName: 'tomorrow',
    //     name: 'Tomorrow',
    //     constant: true,
    // }
  ];

  let aggregation = [
    {
      fieldName: "sum",
      name: "Sum",
      function: true
    },
    {
      fieldName: "find",
      name: "Find",
      function: true
    },
    {
      fieldName: "filter",
      name: "Filter",
      function: true
    },
    {
      fieldName: "sort",
      name: "Sort",
      function: true
    }
  ];

  // if (variableType == 14) {
  //   return [...aggregation];
  // }

  if (variableType == 36 || variableType == 14) {
    return [...informationPart];
  }

  return [...systemPart, ...informationPart, ...constants];
};

export default {
  props: {
    formula: String,
    variables: Array,
    form: Object,
    autofocus: Boolean,
    template: Boolean,
  },
  model: {
    prop: "formula",
    event: "updateFormula"
  },
  //<i class="information-icon ${commons.informationIcon(variableValues[variableValues.length - 1].type)}"><\/i>&nbsp;
  data: () => ({
    regex: /<fts-i-unit contenteditable="false" field="(?<fieldName>.*?)">(?<display>.*?)<\/fts-i-unit>/g,
    regex2: /<fts-i-unit field="(?<fieldName>.*?)" contenteditable="false">(?<display>.*?)<\/fts-i-unit>/g,
    formulaRegex: /#.*\W/g,
    content: "",
    innerExpression: "",
    tributeOptions: {
      trigger: "#",
      allowSpaces: true,
      values: [],
      lookup: "name",
      requireLeadingSpace: false,
      replaceTextSuffix: "",
      containerClass: "tribute-container formula-dropdown-menu",
      itemClass: "formula-dropdown-option",
      noMatchTemplate: () =>
        `<div class="formula-dropdown-option">Not match found.</div>`,
      menuItemTemplate: function(item) {
        let tag = "";
        // if(item.original.moduleId) {
        //   let name = getModule(item.original.moduleId).name;
        //   tag = `<div class="formula-option-tag">${name}</div>`
        // }
        if (item.original.moduleName && item.original.informationId) {
          tag = `<div class="formula-option-tag">${item.original.moduleName} - ${item.original.information.displayName}</div>`;
        } else if (item.original.moduleName && item.original.activityId) {
          tag = `<div class="formula-option-tag">${item.original.moduleName} - ${item.original.activity.name}</div>`;
        } else if (item.original.moduleName) {
          tag = `<div class="formula-option-tag">${item.original.moduleName}</div>`;
        }

        if (item.original.system) {
          tag = `<div class="formula-option-tag" style="background-color: orange;">system</div>`;
        }

        return `
          <i class="formula-option-icon information-icon ${commons.informationIcon(
            item.original.type
          )}"></i>
          <div class="formula-option-label">${item.string}</div>
          ${tag}
        `;
      }
    }
  }),
  methods: {
    debounceInput: _.debounce(function() {
      this.$emit("change");
    }, 800),
    processKeyDown(evt) {
      if (evt.keyCode == 8) {
        if (
          evt.target.lastChild &&
          evt.target.lastChild.nodeName == "#text" &&
          evt.target.lastChild.wholeText == " "
        ) {
          if (
            evt.target.lastChild.previousElementSibling &&
            evt.target.lastChild.previousElementSibling.nodeName == "FTS-I-UNIT"
          ) {
            evt.target.removeChild(evt.target.lastChild.previousElementSibling);
          }
        }
      }

      if (!this.template && evt.keyCode == 13) {
        evt.preventDefault();
      }
    },
    test($event) {
      //console.log($event);
    },
    paste(evt) {
      var text = evt.clipboardData.getData("text/plain");
      document.execCommand("insertHTML", false, text);
    },
    onBlur() {
      this.$emit("blur");
    },
    getModule(id) {
      if (id && this.$store.getters.workspaceModules) {
        const findModule = this.$store.getters.workspaceModules.find(
          x => x.id == id
        );
        if (findModule)
          return {
            id: findModule.id,
            name: findModule.name,
            emoji: findModule.emoji
          };
      }
    },
    updateContent($event) {
      let formulaText = $event.target.innerHTML.replace(this.regex, "{{$1}}");
      formulaText = formulaText.replaceAll("&nbsp;", " ");
      // formulaText = formulaText.replaceAll("<br>", "");
      formulaText = formulaText.replaceAll("&gt;", ">");
      formulaText = formulaText.replaceAll("&lt;", "<");
      formulaText = formulaText.replaceAll("&amp;", "&");
      this.innerExpression = formulaText;
      this.$emit("updateFormula", formulaText);
      this.$emit("input", formulaText);
      this.$emit("change", formulaText);
    },
    async autofill(text, vm, cb) {
      var rangeStart = window.getSelection().getRangeAt(0).startContainer;
      if (
        rangeStart &&
        rangeStart.data &&
        rangeStart.data.indexOf("#") == 0 &&
        findLastFormulaUnit(rangeStart)
      ) {
        let lastUnit = findLastFormulaUnit(rangeStart);
        this.regex.lastIndex = 0;
        this.regex2.lastIndex = 0;

        let result = this.regex.exec(lastUnit.outerHTML);
        if (!result) {
          result = this.regex2.exec(lastUnit.outerHTML);
        }

        if (result) {
          let variablePaths = result.groups.fieldName.split(".");
          let variableValues = [];
          let source = this.variables;
          let lastVariable = null;
          for (let variablePath of variablePaths) {
            //console.log("path:" + variablePath);
            lastVariable = source.find(x => x.fieldName == variablePath);
            variableValues.push(lastVariable);

            if (lastVariable && lastVariable.moduleId) {
              let data = await this.$store.dispatch("findVariable", {
                moduleId: lastVariable.moduleId
              });

              if (lastVariable.informationId) {
                let table = data.information.find(
                  x => x.id == lastVariable.informationId
                );
                source = prepareVariables(
                  table.fields,
                  vm,
                  lastVariable.variableType
                    ? lastVariable.variableType
                    : lastVariable.type
                );
              } else if (lastVariable.activityId) {
                if (lastVariable.name == "Form" && this.form) {
                  let classification = commons.getAllElements(null, this.form);
                  source = prepareVariables(
                    classification,
                    vm,
                    lastVariable.type
                  );
                } else if (
                  lastVariable.activityId == "createEditView" ||
                  lastVariable.activityId == "create" ||
                  lastVariable.activityId == "edit"
                ) {
                  let classification = data.standards.find(
                    x => x.id == lastVariable.activityId
                  ).classification;
                  if (!classification) {
                    classification = data.standards.find(
                      x => x.id == "createEditView"
                    ).classification;
                  }

                  source = prepareVariables(
                    classification,
                    vm,
                    lastVariable.type
                  );
                } else {
                  source = prepareVariables(
                    data.activities.find(x => x.id == lastVariable.activityId)
                      .classification,
                    vm,
                    lastVariable.type
                  );
                }
              } else {
                source = prepareVariables(
                  data.information,
                  vm,
                  lastVariable.type
                );
              }
            }
            if (lastVariable && lastVariable.type == 14) {
              source = prepareVariables(
                lastVariable.fields,
                vm,
                lastVariable.type
              );
            }
          }

          if (lastVariable && lastVariable.type == 14) {
            source = prepareVariables(
              lastVariable.fields,
              vm,
              lastVariable.type
            );
            source.forEach(x => {
              x.parent = result.groups.fieldName;
              x.parents = variableValues;
              x.tableField = true;
            });
            cb(source);
          } else if (lastVariable && lastVariable.moduleId) {
            source.forEach(x => {
              x.parent = result.groups.fieldName;
              x.parents = variableValues;
            });
            cb(source);
          } else {
            this.variables.forEach(variable => {
              if (variable.moduleId) {
                variable.moduleName = vm.getModule(variable.moduleId).name;
              }
            });

            cb(this.variables);
          }
        }
      } else {
        let selection = _.cloneDeep(this.selection);
        selection = selection.concat(commons.formulaConstants);
        selection = selection.concat(commons.formulaTemplates);

        for (const variable of selection) {
          if (variable.moduleId) {
            let data = await this.$store.dispatch("findVariable", {
              moduleId: variable.moduleId
            });
            variable.moduleName = data.name;
            if (variable.variableType) {
              variable.type = variable.variableType;
            }
            if (variable.informationId) {
              variable.information = data.information.find(
                x => x.id == variable.informationId
              );
            }

            if (variable.activityId) {
              variable.activity = data.standards.find(
                x => x.id == variable.activityId
              );
              if (!variable.activity) {
                variable.activity = data.activities.find(
                  x => x.id == variable.activityId
                );
              }
            }

            if (variable.variableType) {
              variable.type = variable.variableType;
            }
          }
        }

        cb(selection);
      }
    },
    selectTemplate(item) {
      let inMiddle = false;
      let selectionNode = window.getSelection();

      // if (selectionNode && selectionNode.anchorNode) {
      //   console.log(selectionNode.anchorNode);
      // }

      // if (
      //   selectionNode &&
      //   selectionNode.anchorNode &&
      //   selectionNode.anchorNode.nextSibling &&
      //   selectionNode.anchorNode.nextSibling.wholeText
      // ) {
      //   console.log(selectionNode.anchorNode.nextSibling.wholeText);
      // }

      if (selectionNode && selectionNode.anchorNode.nextSibling) {
        if (
          selectionNode.anchorNode.nextSibling.wholeText &&
          selectionNode.anchorNode.nextSibling.wholeText.match(
            this.formulaRegex
          )
        ) {
          inMiddle = true;
          console.log("in middle");
        } else if (
          selectionNode.anchorNode.nextSibling.nodeName == "FTS-I-UNIT" 
          || selectionNode.anchorNode.nextSibling.nodeName == "BR"
          || (selectionNode.anchorNode.nextSibling.nextSibling 
          && selectionNode.anchorNode.nextSibling.nextSibling.nodeName == "BR")
        ) {
          inMiddle = true;
          console.log("in middle");
        }
      }

      if (item.original.template) {
        return `${item.original.template}`;
      } else if (item.original.function) {
        return `.${item.original.fieldName}(`;
      } else if (item.original.parent != null) {
        var rangeStart = window.getSelection().getRangeAt(0).startContainer;
        if (
          rangeStart &&
          rangeStart.data &&
          rangeStart.data.indexOf("#") == 0
        ) {
          let lastUnit = findLastFormulaUnit(rangeStart);
          if (lastUnit) {
            lastUnit.remove();
          }
        }

        var variablePaths = `${item.original.parent}.${item.original.fieldName}`.split(
          "."
        );
        var variableValues = [];
        var source = this.variables;
        for (let variablePath of variablePaths) {
          var variable = source.find(x => x.fieldName == variablePath);
          variableValues.push(variable);
        }

        this.$emit("lastVariable", item.original);

        return (
          `<fts-i-unit contenteditable="false" field="${item.original.parent}.${
            item.original.fieldName
          }"><i class="information-icon ${commons.informationIcon(
            item.original.type
          )}"><\/i>&nbsp;${item.original.parents
            .map(x => `<span class="variable">${x.name}</span>`)
            .join(
              "<span class='path-indicator'>'s</span>&nbsp;"
            )}<span class='path-indicator'>'s</span>&nbsp; <span class="variable">${
            item.original.name
          }</span></fts-i-unit>` +
          (inMiddle ? "" : " ") +
          (!item.original.moduleId && item.original.type != 14 ? " " : "")
        );
      }

      this.$emit("lastVariable", item.original);
      let elementResult =
        `<fts-i-unit contenteditable="false" field="${
          item.original.fieldName
        }"><i class="information-icon ${commons.informationIcon(
          item.original.type
        )}"><\/i>&nbsp;<span class="variable">${
          item.original.name
        }</span></fts-i-unit>` + (inMiddle ? "" : " "); // + (item.original.moduleId ? "" : " ");

      return elementResult;
    },
    async updateDisplay(formula) {
      let re = /{{(?<fieldName>[\w|\.]*?)}}/g;

      try {
        let match = re.exec(formula);
        this.content = formula;
        let selection = _.cloneDeep(this.variables);
        selection = selection.concat(commons.formulaConstants);

        while (match != null) {
          let variablePaths = match[1].split(".");
          let variableValues = [];
          let source = selection;

          let lastVariable,
            previousVariable = null;
          for (let variablePath of variablePaths) {
            previousVariable = lastVariable;
            lastVariable = source.find(x => x.fieldName == variablePath);

            if (
              !lastVariable &&
              previousVariable &&
              previousVariable.type == 14
            ) {
              source = prepareVariables(
                previousVariable.fields,
                this,
                previousVariable.type
              );
              lastVariable = source.find(x => x.fieldName == variablePath);
            }

            variableValues.push(lastVariable);

            if (lastVariable && lastVariable.moduleId) {
              let data = await this.$store.dispatch("findVariable", {
                moduleId: lastVariable.moduleId
              });

              if (lastVariable.informationId) {
                source = prepareVariables(
                  data.information.find(
                    x => x.id == lastVariable.informationId
                  )["fields"],
                  this,
                  lastVariable.type
                );
              } else {
                source = prepareVariables(
                  data.information,
                  this,
                  lastVariable.type
                );
              }
            } else if (lastVariable && lastVariable.type == 14) {
              source = prepareVariables(
                lastVariable.fields,
                this,
                lastVariable.type
              );
            }
          }
          //<i class="information-icon fts-icon-text"><\/i>&nbsp;
          this.content = this.content.replace(
            match[0],
            `<fts-i-unit contenteditable="false" field="${
              match[1]
            }"><i class="information-icon ${commons.informationIcon(
              variableValues[variableValues.length - 1].type
            )}"><\/i>&nbsp;${variableValues
              .map(x => `<span class="variable">${x.name}</span>`)
              .join(
                "<span class='path-indicator'>'s</span>&nbsp;"
              )}</fts-i-unit>`
          );
          match = re.exec(formula);
        }
      } catch (err) {
        console.warn(`FTSExpression error: ${err}`);
      }

      this.innerExpression = formula;
    }
  },
  components: {
    VueTribute
  },
  watch: {
    formula(newVal) {
      if (!newVal) {
        this.content = "";
        this.innerExpression = "";
        this.$refs.formulaExpression.innerHTML = "";
      }
    },
    async variables(newVal) {
      await this.updateDisplay(this.formula);
    }
  },
  computed: {
    selection() {
      return this.variables;
    }
  },
  async mounted() {
    let vm = this;
    this.tributeOptions.selectTemplate = this.selectTemplate;
    this.tributeOptions.values = function(text, cb) {
      vm.autofill(text, vm, users => cb(users));
    };

    if (this.autofocus) this.$refs.formulaExpression.focus();

    await this.updateDisplay(this.formula);
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-expression {
  // padding: 3px;
  color: var(--fts-form-control);
  cursor: text;
  .formula {
    &:empty:before {
      content: attr(placeholder);
      -webkit-text-fill-color: var(--fts-form-control-placeholder);
    }
    fts-i-unit {
      background-color: aliceblue;
      padding: 3px;
      margin: 2px;

      .information-icon {
        color: var(--fts-gray-5);
        font-size: 90%;
      }
      .variable {
        color: orange;
        font-weight: 600;
      }
      .path-indicator {
        color: var(--fts-gray-5);
      }
    }
  }
  .editor-expression {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 0.675rem;
    color: var(--fts-gray-5);
  }
}
/* dropdown menu */
.formula-dropdown-menu {
  min-width: 200px;
  padding: 0.375rem 0;
  overflow: auto;
  box-shadow: var(--fts-elevation-3);
  border-radius: 0.25rem;
  background: #fff;
  font-size: 1rem;
  > ul {
    margin: 0;
    background: inherit;
  }
  .formula-dropdown-option {
    display: flex;
    align-items: flex-start;
    padding: 0.375rem 0.75rem;
    background: inherit;
    &:hover {
      cursor: pointer;
    }
    &.highlight {
      background: #eee;
    }
    .formula-option-icon {
      margin-top: 0.135rem;
      margin-right: 0.575rem;
      .default {
        color: $primaryColor;
      }
      color: $secondaryColor;
    }
    .formula-option-label {
      flex: 1;
      min-height: calc(1rem + 0.135rem + 0.135rem);
    }
    .formula-option-tag {
      margin-left: 0.575rem;
      padding: calc(0.135rem + 1px) 0.275rem;
      font-size: calc(1rem - 0.135rem - 0.135rem);
      border-radius: 0.25rem;
      background: $primaryColor;
      color: lighten($primaryColor, 45%);
      &.system {
        //
      }
      &.variable {
        //
      }
    }
  }
}
</style>